import { useCallback } from 'react'
import { useReactFlow } from '@xyflow/react'
import { createNode } from '@/entities/flow'
import { readNodeCustomDataSnapshot } from './node-custom-data'
import { toast } from 'sonner'
import type { BaseNodeData } from '@/shared/lib/node-registry'

/**
 * 将当前节点提取为一个新节点，放在右侧。
 */
export function useExtractNode(nodeId: string | undefined, nodeType?: string | null) {
  const { getInternalNode } = useReactFlow()

  return useCallback((e?: React.MouseEvent) => {
    if (e && e.stopPropagation) e.stopPropagation()
    if (!nodeId) return

    const snapshot = readNodeCustomDataSnapshot<BaseNodeData>(nodeId)
    const internalNode = getInternalNode(nodeId)
    const nodeX = internalNode?.internals.positionAbsolute?.x ?? 0
    const nodeY = internalNode?.internals.positionAbsolute?.y ?? 0
    const nodeWidth = internalNode?.internals.userNode.measured?.width
      ?? internalNode?.internals.userNode.width
      ?? 320

    createNode({
      type: nodeType || 'video',
      position: { x: nodeX + nodeWidth + 48, y: nodeY },
      customData: {
        title: snapshot.title ?? '提取的节点',
        op: snapshot.op ?? 'material',
        assetRefs: snapshot.assetRefs as string[] | undefined,
      },
    })

    toast.success('已提取到画布')
  }, [getInternalNode, nodeId, nodeType])
}
